export default __webpack_public_path__ + "static/media/Close.58cf0159.svg";